import type { QueryErrorResponse } from '~/types'

interface QueryEvents<RespT, ErrT> {
  onSuccess: (resp: RespT) => unknown
  onError: (resp: ErrT) => unknown
}

export function useQueryEvents<RespT, ErrT = QueryErrorResponse>(
  query: ReturnType<RespT, ErrT>,
  callbacks: Partial<QueryEvents<RespT, ErrT>>,
) {
  const { onSuccess, onError } = callbacks

  watchEffect(() => {
    if (query.dataUpdatedAt.value) {
      if (query.data.value && typeof onSuccess === 'function')
        onSuccess(query.data.value)
    }
  })

  watchEffect(() => {
    if (query.errorUpdatedAt.value) {
      if (query.error.value && typeof onError === 'function')
        onError(query.error.value)
    }
  })
}
